import { Card, CardContent, Grid } from "@mui/material";
import BackofficeSettlementAdministrator from "../../../components/backoffice-settlement-administrator";

const SettlementAdministrator = () => {
  return (
    <>
      <Grid
        container
        pt="0px"
        spacing={2}
        sx={{
          heigth: "auto",
          width: "auto",
          marginBottom: 3,
          marginTop: 0,
          paddingBottom: 22,
        }}
      >
        <Grid item xs={12}>
          <Card
            elevation={3}
            align="center"
            sx={{ heigth: "auto", width: "auto" }}
          >
            <CardContent>
              <BackofficeSettlementAdministrator />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default SettlementAdministrator;
